import { ArrowRightCircle } from "react-feather";
import { H6, P } from "../../../../../AbstractElements";
import { UXDesigners } from "../../../../../Constant";
import { FULLSCREEN_UX_LIST } from "../../../../../Data/UiKit/Modal";

const UXDesigner = () => {
  return (
    <>
      <div className="large-modal-header mt-4">
        <H6>{UXDesigners}</H6>
      </div>
      <div className="d-flex mt-3">
        <div className="flex-shrink-0"><ArrowRightCircle className="svg-modal"/></div>
        <div className="flex-grow-1 ms-2">
          <P className="mb-0">User research, persona creation, building wireframes and interactive prototypes, and testing ideas are among the common tasks of a UX designer. These duties can differ greatly between organizations.</P>
        </div>
      </div>
      {FULLSCREEN_UX_LIST.map((item, index) => (
        <div className="d-flex mt-1" key={index}>
          <div className="flex-shrink-0"><ArrowRightCircle className="svg-modal"/></div>
          <div className="flex-grow-1 ms-2"><P className="mb-0">{item}</P></div>
        </div>
      ))}
    </>
  )
};

export default UXDesigner;
